<template>
<div>
  <!-- 消息通知 -->
  <div @click="notificationVisible = true; getNotificationCount()" >
    <lls-badge class="item">
      <img class="notification" src="@/assets/topBar/notification.svg" />
      <lls-badge v-if="notificationCountObj.totalCount && notificationCountObj.totalCount > 0" :value="notificationCountObj.totalCount" :max="99" style="margin-top: -13px; margin-left: -10px;"></lls-badge>
    </lls-badge>
  </div>
  <!-- 消息盒子 -->
  <el-drawer
    :title="$t('message.notificationsList')"
    :visible.sync="notificationVisible"
    direction="rtl"
    :size="drawerWidth"
    class="custom-drawer">
    <!-- 消息组件 -->
    <NotificationList 
      v-if="notificationVisible" 
      @refreshCount="getNotificationCount" 
      @fetchMarkedMsg="fetchMarkedMsg" 
      :countObj="notificationCountObj">
    </NotificationList>
  </el-drawer>
</div>
</template>

<script>
import NotificationList from '@/views/notification/List'
import PushMessageContent from './coms/PushMessageContent.vue';
import { mapActions } from 'vuex'
import { dur } from './func.js'

export default {
  data() {
    return {
      notificationVisible: false,
      notificationCountObj: {},
      intervalKey: null,
      enterpriseData: [{
        id: ''
      }],
      pushMsg: [],
      isZh: this.$i18n.locale == 'zh',
      drawerWidth: '440px' // 初始宽度设置，先按大屏宽度设置
    }
  },
  props: {
    
  },
  components: {
    NotificationList
  },
  mounted() {
    // 轮询查待办数量
    this.intervalKey = setInterval(() => {
      this.getNotificationCount()
    }, 10000)
    
    // push 未读消息
    this.getPushlistUndeal()

    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // 销毁时移除定时器
    clearInterval(this.intervalKey)
    this.$notify.closeAll()
    this.notificationVisible = false

    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    ...mapActions(['updateMessageCountAction']),
    handleResize() {
      const screenWidth = document.documentElement.clientWidth;
      if (screenWidth < 1280) {
        this.drawerWidth = '350px';
      } else if (screenWidth < 1680) {
        this.drawerWidth = '30%';
      } else {
        this.drawerWidth = '440px';
      }
    },
    async getPushlistUndeal () {
      let userData = sessionStorage.getItem('objCurUserInfo') || ''
      const enterpriseId = sessionStorage.getItem('enterpriseId') || ''
      userData = JSON.parse(userData)

      let res

      const params = {
        enterpriseId,
        userId: userData.id
      }
      res = await this.$API.system.getPushlistUndeal(params)
      
      const code = res.data.code
      if (code == '200') {
        const resData = res.data.data
        // const pushData = resData.slice(0,2)
        let pushData = resData.filter((item, index) => {
          return item.priority === 1 && index < 2;
        })

        // 如果刷新的数据跟之前是一样的，就不改变现有的；否则刷新数据
        if (JSON.stringify(pushData) === JSON.stringify(this.pushMsg)) {
          return
        } else {
          this.pushMsg = pushData  
        }
        
        this.$notify.closeAll()
        const isZh = this.isZh
        pushData.forEach((item, index) => {
          const itemData = {
            ...item,
            dur: dur(item.createTime)
          }
          setTimeout(() => {
            this.$notify({
              offset: 50,
              title: '',
              showClose: item.msgType == 1,
              customClass: `push-priority push-priority-${item.priority}`,
              message: this.$createElement(
                PushMessageContent,{
                  props: {
                    isZh,
                    itemData,
                    msgType: item.msgType // 1-message  2-todo
                  },
                  on: {
                    refreshCount: this.updateMessageList
                  }
                }
              ),
              duration: 0
              // onClose: () => this.fetchMarkedMsg(item.id, item.msgType === 1 ? 1 : 3) // 读，全部读or办理   1:已读 2:已全部读 3:已办理
            });
          }, 1000 * index)
        })
      }
    },
    updateMessageList () {
      this.updateMessageCountAction()
    },
    async fetchMarkedMsg(id, updType) {
      let params = {
        id,
        updType // 读，全部读or办理   1:已读 2:已全部读 3:已办理
      }
      // 自行处理错误信息
      try {
        const data = await this.$API.system.updateHandleStatus(params)
        var code = data.data.code;
        if (code == "200") {
          // this.fetchData()
          this.$emit('refreshCount') // 更新待办数量
          // 点击单行不提示成功
          if (updType !== 1) {
            this.$message({
              type: 'success',
              message: 'success',
              customClass: 'custom-message',
            });
          }
  
          return true
        }
      } catch (err) {
        this.$message({
          type: 'error',
          message: err,
          customClass: 'custom-message',
        });
      }
    },
   
    // 获取代办消息
    async getNotificationCount() {
      let userData = sessionStorage.getItem('objCurUserInfo') || ''
      const enterpriseId = sessionStorage.getItem('enterpriseId') || ''
      userData = JSON.parse(userData)

      try {
        const params = {
          // enterpriseId,
          // userId: userData.id
        }
        let res = await this.$API.system.getNotificationcount(params)
        const data = res.data;
        if (data.code == "200") {
          // 触发事件，将数据传递给父组件
          this.$emit('notification-count', data.data)

          const resData = data.data.notificationCount
          // 三类数据，只要其中一个发生了变化，就代表需要刷新 push 和 列表
          if (resData && (
            resData.totalCount !== this.notificationCountObj.totalCount ||
            resData.unHandleCount !== this.notificationCountObj.unHandleCount ||
            resData.unReadCount !== this.notificationCountObj.unReadCount)
          ) {
            // vuex 通知列表去刷新数据
            this.updateMessageList()
            // 更新 push 
            this.getPushlistUndeal()
          }
          this.notificationCountObj =  resData || {}
        } else {
          // 异常时移除定时器
          clearInterval(this.intervalKey)
        }
      } catch (error) {
        // 异常时移除定时器
        clearInterval(this.intervalKey)
      }
    },
  }
}
</script>

<style scoped lang="scss">
.notification {
  width: 20px;
  cursor: pointer;
}

</style>
<style lang="scss">
.push-priority {
  border-radius: 4px!important;
  width: 380px !important;
  z-index: 99 !important;
  .lls-notification__closeBtn {
    top: 14px
  }
}
.push-priority-1 {  // 接口优先级字段为 1
  border: 1px solid #F76C5E80!important;
  // background-color: #F76C5E0D !important;
}
.push-priority-2, .push-priority-3 {  // 接口优先级字段为 2 \ 3
  border: 1px solid #5A9CF880!important;
  // background-color: #5A9CF80D !important;
}
.custom-drawer {
  .el-drawer__header {
    color: #1E293B;
    font-size: 20px;
    font-weight: 600;
    line-height: 30px;
  }
}
</style>


